<script setup lang="ts">
import DividerLine from '@/uiKit/DividerLine.vue'

defineOptions({
  name: 'MenuDivider',
})
</script>

<template>
  <DividerLine
    class="my-0.5 -ml-0.5 w-[calc(100%+0.25rem)]!"
    color="subtle"
  />
</template>
